import React, { useEffect, useMemo, useState } from "react";
import { KpiCard } from "../../../Component/AgentComponents/KpiCard";
import { SectionCard } from "../../../Component/AgentComponents/SectionCard";
import { Badge } from "../../../Component/AgentComponents/Badge";
import Pagination from "../../../Component/Common/Pagination";
import { BASE_URL } from "../../../config/api";

/* -------------------- ALL MOCK DATA HERE --------------------- */
const mockRetailers = [
  {
    id: 1,
    name: "Shree Mobile Store",
    isSelling: true,
    monthlySales: 75000,
    totalSales: 450000,
    commissionRate: 0.04,
    monthCommission: 3000,
    totalCommission: 18000,
  },
  {
    id: 2,
    name: "Sai Telecom",
    isSelling: false,
    monthlySales: 12000,
    totalSales: 120000,
    commissionRate: 0.035,
    monthCommission: 420,
    totalCommission: 4200,
  },
  {
    id: 3,
    name: "Om Electronics",
    isSelling: false,
    monthlySales: 0,
    totalSales: 80000,
    commissionRate: 0.03,
    monthCommission: 0,
    totalCommission: 2400,
  },
  {
    id: 4,
    name: "Mahalaxmi General Store",
    isSelling: true,
    monthlySales: 50000,
    totalSales: 50000,
    commissionRate: 0.05,
    monthCommission: 2500,
    totalCommission: 2500,
  },
];

const mockCommissionEntries = [
  {
    id: 501,
    date: "2025-11-10",
    retailerId: 1,
    retailerName: "Shree Mobile Store",
    invoiceAmount: 25000,
    rate: 0.04,
    commissionAmount: 1000,
    remark: "Recharge + DMT",
  },
  {
    id: 502,
    date: "2025-11-09",
    retailerId: 4,
    retailerName: "Mahalaxmi General Store",
    invoiceAmount: 20000,
    rate: 0.05,
    commissionAmount: 1000,
    remark: "POS license + bill pay",
  },
  {
    id: 503,
    date: "2025-11-05",
    retailerId: 2,
    retailerName: "Sai Telecom",
    invoiceAmount: 12000,
    rate: 0.035,
    commissionAmount: 420,
    remark: "Low activity month",
  },
];

const mockPayouts = [
  {
    id: 801,
    weekLabel: "Week 1: 03 Nov - 09 Nov 2025",
    weekStart: "2025-11-03",
    weekEnd: "2025-11-09",
    totalCommission: 2420,
    payoutStatus: "Transferred",
    bankName: "HDFC Bank",
    accountNumberLast4: "4321",
    ifsc: "HDFC0001234",
    transactionId: "TXN20251110001",
    payoutDate: "2025-11-10",
  },
  {
    id: 802,
    weekLabel: "Week 2: 10 Nov - 16 Nov 2025",
    weekStart: "2025-11-10",
    weekEnd: "2025-11-16",
    totalCommission: 1800,
    payoutStatus: "Pending",
    bankName: "SBI",
    accountNumberLast4: "7788",
    ifsc: "SBIN0005678",
    transactionId: "",
    payoutDate: "",
  },
];

/* -------------------- MAIN COMPONENT --------------------- */
export default function CommissionView() {
  const retailers = mockRetailers;
  const commissionEntries = mockCommissionEntries;
  const payouts = mockPayouts;

  const [entryPage, setEntryPage] = useState(1);
  const [payoutPage, setPayoutPage] = useState(1);

  const itemsPerPage = 1;

  const [retailerFilter, setRetailerFilter] = useState("all");

  const [kpis, setKpis] = useState({
  monthCommission: 0,
  lifetimeCommission: 0,
  sellingRetailers: 0,
  avgCommissionPerRetailer: 0,
});


  /* -------- KPIs AUTO-CALCULATED HERE -------- */
  // const kpis = useMemo(() => {
  //   const totalOnboarded = retailers.length;
  //   const sellingRetailers = retailers.filter((r) => r.isSelling).length;

  //   const monthCommission = retailers.reduce(
  //     (sum, r) => sum + (r.monthCommission || 0),
  //     0
  //   );
  //   const lifetimeCommission = retailers.reduce(
  //     (sum, r) => sum + (r.totalCommission || 0),
  //     0
  //   );

  //   const avgCommissionPerRetailer =
  //     totalOnboarded > 0 ? monthCommission / totalOnboarded : 0;

  //   return {
  //     totalOnboarded,
  //     sellingRetailers,
  //     monthCommission,
  //     lifetimeCommission,
  //     avgCommissionPerRetailer,
  //   };
  // }, []);



  useEffect(() => {
  const fetchCommissionDashboard = async () => {
    try {
      const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
      const agentId = authUser?.id;
      if (!agentId) return;

      const res = await fetch(
        `${BASE_URL}warranty/commission-dashboard?agent_id=${agentId}`
      );
      const json = await res.json();

      if (!res.ok || !json.status) return;

      const d = json.data;

      setKpis({
        monthCommission: d.expected_commission_current_cycle ?? 0,
        lifetimeCommission: d.all_time_commission_paid ?? 0,
        sellingRetailers: d.total_commission_rows ?? 0,
        avgCommissionPerRetailer: d.average_payout_per_row ?? 0,
      });
    } catch (err) {
      console.error("Commission dashboard error:", err);
    }
  };

  fetchCommissionDashboard();
}, []);


  /* -------- FILTER ENTRIES -------- */
  const filteredEntries = useMemo(
    () =>
      retailerFilter === "all"
        ? commissionEntries
        : commissionEntries.filter(
            (e) => String(e.retailerId) === retailerFilter
          ),
    [commissionEntries, retailerFilter]
  );

  const filteredPayouts = payouts;

  const totalEntryPages = Math.ceil(filteredEntries.length / itemsPerPage);

  const paginatedEntries = useMemo(() => {
    const start = (entryPage - 1) * itemsPerPage;
    return filteredEntries.slice(start, start + itemsPerPage);
  }, [filteredEntries, entryPage]);

    useEffect(() => {
    setEntryPage(1);
  }, [retailerFilter]);

  const totalPayoutPages = Math.ceil(filteredPayouts.length / itemsPerPage);

  const paginatedPayouts = useMemo(() => {
    const start = (payoutPage - 1) * itemsPerPage;
    return filteredPayouts.slice(start, start + itemsPerPage);
  }, [filteredPayouts, payoutPage]);



  return (
    <div className="space-y-4">
      {/* KPIs */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <KpiCard
            label="This Month Commission"
            value={`₹${kpis.monthCommission}`}
            subLabel="Expected payout"
          />

          <KpiCard
            label="Lifetime Commission"
            value={`₹${kpis.lifetimeCommission}`}
            subLabel="Total earnings"
          />

          <KpiCard
            label="Retailers Selling"
            value={kpis.sellingRetailers}
            subLabel="Commission rows"
          />

          <KpiCard
            label="Avg Comm. / Retailer"
            value={`₹${kpis.avgCommissionPerRetailer}`}
            subLabel="Per payout"
          />

      </div>

      {/* Commission Table */}
      <SectionCard
        title="Recent Commission Entries"
        right={
          <select
            value={retailerFilter}
            onChange={(e) => setRetailerFilter(e.target.value)}
            className="text-xs border border-slate-200 rounded-lg px-2 py-1 bg-slate-50"
          >
            <option value="all">All retailers</option>
            {retailers.map((r) => (
              <option key={r.id} value={String(r.id)}>
                {r.name}
              </option>
            ))}
          </select>
        }
      >
        <div className="overflow-x-auto">
          <table className="min-w-full text-xs">
            <thead>
              <tr className="border-b text-slate-500">
                <th className="py-2 text-left">Date</th>
                <th className="py-2 text-left">Retailer</th>
                <th className="py-2 text-right">Invoice</th>
                <th className="py-2 text-right">Rate</th>
                <th className="py-2 text-right">Commission</th>
                <th className="py-2 text-left">Remark</th>
              </tr>
            </thead>

            <tbody>
              {paginatedEntries.map((entry) => (
                <tr key={entry.id} className="border-b bg-white hover:bg-blue-50">
                  <td className="py-1.5">{entry.date}</td>
                  <td className="py-1.5">
                    <div className="font-medium">{entry.retailerName}</div>
                    <div className="text-[10px] text-slate-500">
                      ID: {entry.retailerId}
                    </div>
                  </td>
                  <td className="py-1.5 text-right">
                    ₹{entry.invoiceAmount.toLocaleString()}
                  </td>
                  <td className="py-1.5 text-right">
                    {(entry.rate * 100).toFixed(1)}%
                  </td>
                  <td className="py-1.5 text-right text-blue-700">
                    ₹{entry.commissionAmount.toLocaleString()}
                  </td>
                  <td className="py-1.5">{entry.remark}</td>
                </tr>
              ))}

              {filteredEntries.length === 0 && (
                <tr>
                  <td
                    colSpan={6}
                    className="py-4 text-center text-slate-500"
                  >
                    No commission entries available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {totalEntryPages > 1 && (
            <div className="flex justify-end mt-3">
              <Pagination
                currentPage={entryPage}
                totalPages={totalEntryPages}
                onPageChange={setEntryPage}
              />
            </div>
          )}
        </div>
      </SectionCard>

      {/* Payouts Table */}
      <SectionCard title="Weekly Commission Payouts">
        <div className="overflow-x-auto">
          <table className="min-w-full text-xs">
            <thead>
              <tr className="border-b text-slate-500">
                <th className="py-2 text-left">Week</th>
                <th className="py-2 text-left">Period</th>
                <th className="py-2 text-right">Total Commission</th>
                <th className="py-2 text-left">Status</th>
                <th className="py-2 text-left">Bank</th>
                <th className="py-2 text-left">IFSC</th>
                <th className="py-2 text-left">Txn ID</th>
                <th className="py-2 text-left">Payout Date</th>
              </tr>
            </thead>

            <tbody>
              {paginatedPayouts.map((p) => (
                <tr key={p.id} className="border-b bg-white hover:bg-blue-50">
                  <td className="py-1.5">{p.weekLabel}</td>
                  <td className="py-1.5">
                    {p.weekStart} → {p.weekEnd}
                  </td>
                  <td className="py-1.5 text-right text-blue-700">
                    ₹{p.totalCommission.toLocaleString()}
                  </td>
                  <td className="py-1.5">
                    <Badge color={p.payoutStatus === "Transferred" ? "green" : "yellow"}>
                      {p.payoutStatus}
                    </Badge>
                  </td>
                  <td className="py-1.5">
                    {p.bankName}
                    <div className="text-[10px] text-slate-500">
                      A/C ****{p.accountNumberLast4}
                    </div>
                  </td>
                  <td className="py-1.5">{p.ifsc}</td>
                  <td className="py-1.5">{p.transactionId || "-"}</td>
                  <td className="py-1.5">{p.payoutDate || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {totalPayoutPages > 1 && (
            <div className="flex justify-end mt-3">
              <Pagination
                currentPage={payoutPage}
                totalPages={totalPayoutPages}
                onPageChange={setPayoutPage}
              />
            </div>
          )}
        </div>
      </SectionCard>
    </div>
  );
}




// import React, { useMemo, useState } from "react";
// import { KpiCard } from "../../../Component/AgentComponents/KpiCard";
// import { SectionCard } from "../../../Component/AgentComponents/SectionCard";
// import { Badge } from "../../../Component/AgentComponents/Badge";


// export default function CommissionView({
//   kpis,
//   commissionEntries = [],
//   payouts = [],
//   retailers = [],
// }) {
//   const completedRetailers = retailers.filter((r) => r.isSelling).length;
//   const [retailerFilter, setRetailerFilter] = useState("all");

//   const filteredEntries = useMemo(
//     () =>
//       retailerFilter === "all"
//         ? commissionEntries
//         : commissionEntries.filter(
//             (e) => String(e.retailerId) === retailerFilter
//           ),
//     [commissionEntries, retailerFilter]
//   );

//   const filteredPayouts = useMemo(() => payouts || [], [payouts]);

//   return (
//     <div className="space-y-4">
//       {/* KPIs */}
//       <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
//         <KpiCard
//           label="This Month Commission"
//           value={`₹${kpis.monthCommission.toFixed(0)}`}
//           subLabel="Expected payout"
//         />
//         <KpiCard
//           label="Lifetime Commission"
//           value={`₹${kpis.lifetimeCommission.toFixed(0)}`}
//           subLabel="Total earnings"
//         />
//         <KpiCard
//           label="Retailers Selling"
//           value={completedRetailers}
//           subLabel={`Out of ${kpis.totalOnboarded} onboarded`}
//         />
//         <KpiCard
//           label="Avg Comm. / Retailer"
//           value={`₹${kpis.avgCommissionPerRetailer.toFixed(0)}`}
//           subLabel="This month"
//         />
//       </div>

//       {/* Commission Table */}
//       <SectionCard
//         title="Recent Commission Entries"
//         right={
//           <div className="flex items-center gap-2">
//             <select
//               value={retailerFilter}
//               onChange={(e) => setRetailerFilter(e.target.value)}
//               className="text-xs border border-slate-200 rounded-lg px-2 py-1 bg-slate-50"
//             >
//               <option value="all">All retailers</option>
//               {retailers.map((r) => (
//                 <option key={r.id} value={String(r.id)}>
//                   {r.name}
//                 </option>
//               ))}
//             </select>
//             <button className="hidden md:inline-flex text-[11px] px-2 py-1 rounded-lg border border-blue-200 text-blue-700 bg-blue-50 hover:bg-blue-100">
//               ⬇ Download statement
//             </button>
//           </div>
//         }
//       >
//         <div className="overflow-x-auto">
//           <table className="min-w-full text-xs">
//             <thead>
//               <tr className="border-b border-slate-100 text-slate-500">
//                 <th className="py-2 text-left">Date</th>
//                 <th className="py-2 text-left">Retailer</th>
//                 <th className="py-2 text-right">Invoice</th>
//                 <th className="py-2 text-right">Rate</th>
//                 <th className="py-2 text-right">Commission</th>
//                 <th className="py-2 text-left">Remark</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredEntries.map((entry) => (
//                 <tr
//                   key={entry.id}
//                   className="border-b border-slate-50 bg-white hover:bg-blue-50/60"
//                 >
//                   <td className="py-1.5 text-xs text-slate-700">
//                     {entry.date}
//                   </td>
//                   <td className="py-1.5 text-xs text-slate-700">
//                     <div className="font-medium">{entry.retailerName}</div>
//                     <div className="text-[10px] text-slate-500">
//                       ID: {entry.retailerId}
//                     </div>
//                   </td>
//                   <td className="py-1.5 text-xs text-right text-slate-700">
//                     ₹{entry.invoiceAmount.toLocaleString()}
//                   </td>
//                   <td className="py-1.5 text-xs text-right text-slate-700">
//                     {(entry.rate * 100).toFixed(1)}%
//                   </td>
//                   <td className="py-1.5 text-xs text-right text-blue-700">
//                     ₹{entry.commissionAmount.toLocaleString()}
//                   </td>
//                   <td className="py-1.5 text-[11px] text-slate-600">
//                     {entry.remark}
//                   </td>
//                 </tr>
//               ))}
//               {filteredEntries.length === 0 && (
//                 <tr>
//                   <td
//                     colSpan={6}
//                     className="py-4 text-center text-xs text-slate-500"
//                   >
//                     No commission entries available.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </SectionCard>

//       {/* Payout Status Table */}
//       <SectionCard title="Weekly Commission Payouts">
//         <div className="overflow-x-auto">
//           <table className="min-w-full text-xs">
//             <thead>
//               <tr className="border-b border-slate-100 text-slate-500">
//                 <th className="py-2 text-left">Week</th>
//                 <th className="py-2 text-left">Period</th>
//                 <th className="py-2 text-right">Total Commission</th>
//                 <th className="py-2 text-left">Status</th>
//                 <th className="py-2 text-left">Bank</th>
//                 <th className="py-2 text-left">IFSC</th>
//                 <th className="py-2 text-left">Txn ID</th>
//                 <th className="py-2 text-left">Payout Date</th>
//                 <th className="py-2 text-left">Statement</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredPayouts.map((p) => (
//                 <tr
//                   key={p.id}
//                   className="border-b border-slate-50 bg-white hover:bg-blue-50/60"
//                 >
//                   <td className="py-1.5 text-xs text-slate-700 font-medium">
//                     {p.weekLabel}
//                   </td>
//                   <td className="py-1.5 text-[11px] text-slate-700">
//                     {p.weekStart} → {p.weekEnd}
//                   </td>
//                   <td className="py-1.5 text-xs text-right text-blue-700">
//                     ₹{(p.totalCommission || 0).toLocaleString()}
//                   </td>
//                   <td className="py-1.5 text-xs">
//                     <Badge
//                       color={
//                         p.payoutStatus === "Transferred" ? "green" : "yellow"
//                       }
//                     >
//                       {p.payoutStatus}
//                     </Badge>
//                   </td>
//                   <td className="py-1.5 text-[11px] text-slate-700">
//                     {p.bankName} 
//                     {p.accountNumberLast4 && (
//                       <div className="text-[10px] text-slate-500">
//                         A/C ****{p.accountNumberLast4}
//                       </div>
//                     )}
//                   </td>
//                   <td className="py-1.5 text-[11px] text-slate-700">
//                     {p.ifsc || "-"}
//                   </td>
//                   <td className="py-1.5 text-[11px] text-slate-700">
//                     {p.transactionId || "-"}
//                   </td>
//                   <td className="py-1.5 text-[11px] text-slate-700">
//                     {p.payoutDate || "-"}
//                   </td>
//                   <td className="py-1.5 text-[11px] text-slate-700">
//                     <div className="flex flex-col gap-1">
//                       <button className="px-2 py-0.5 rounded-lg border border-blue-200 text-blue-700 bg-blue-50 hover:bg-blue-100 text-[10px]">
//                         View
//                       </button>
//                       <button className="px-2 py-0.5 rounded-lg border border-slate-200 text-slate-700 bg-slate-50 hover:bg-slate-100 text-[10px]">
//                         Download
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//               {filteredPayouts.length === 0 && (
//                 <tr>
//                   <td
//                     colSpan={9}
//                     className="py-4 text-center text-xs text-slate-500"
//                   >
//                     No weekly payout records available.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </SectionCard>

//       {/* Summary */}
//       <SectionCard title="Summary & Tips">
//         <ul className="list-disc list-inside text-xs text-slate-600 space-y-1">
//           <li>
//             You manage{" "}
//             <span className="font-semibold text-slate-800">
//               {kpis.totalOnboarded} retailers
//             </span>
//             ,{" "}
//             <span className="font-semibold text-emerald-700">
//               {kpis.sellingRetailers} are selling
//             </span>{" "}
//             actively.
//           </li>
//           <li>
//             This month commission is{" "}
//             <span className="font-semibold text-blue-700">
//               ₹{kpis.monthCommission.toFixed(0)}
//             </span>{" "}
//             with lifetime earnings of{" "}
//             <span className="font-semibold text-blue-700">
//               ₹{kpis.lifetimeCommission.toFixed(0)}
//             </span>
//             .
//           </li>
//           <li>
//             Focus on{" "}
//             <span className="font-semibold text-amber-700">
//               inactive / not selling retailers
//             </span>{" "}
//             to boost both onboarding quality and commission.
//           </li>
//         </ul>
//       </SectionCard>
//     </div>
//   );
// }